export default {
  en: {
    teamModeTitle: 'Projects',
    singleModeTitle: 'My projects',
  },

  ru: {
    teamModeTitle: 'Проекты',
    singleModeTitle: 'Мои проекты',
  },
}
